export enum API {
    WISH_LISTS_WITH_IMAGES_LITE_MODE = '/wish-lists?lite=true&includesImages=true&productMode=true',
    WISH_LISTS = '/wish-lists',
    NOTIFICATION_EMAIL = '/quick-view/email-me',
}
